import { LanguageList } from 'store/ducks/globalTypes';
import i18n from 'constants/translation/i18n';

const languagesPage = (currentLang?: string) => {
  // Force re-evaluation when language changes
  if (currentLang) {
    i18n.changeLanguage(currentLang);
  }

  const languages = [
    {
      label: i18n.t('ENGLISH'),
      value: LanguageList.EN
    },
    {
      label: i18n.t('GERMAN'),
      value: LanguageList.DE
    },
    {
      label: i18n.t('FRENCH'),
      value: LanguageList.FR
    },
    {
      label: i18n.t('ITALIAN'),
      value: LanguageList.IT
    },
    {
      label: i18n.t('SPANISH'),
      value: LanguageList.ES
    },
    {
      label: i18n.t('PORTUGUESE'),
      value: LanguageList.PT
    }
  ];
  return languages;
};

export default languagesPage;
